"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 50 41"
  }, react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
    id: "a",
    x1: "56.629%",
    x2: "38.601%",
    y1: "76.167%",
    y2: "25.57%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#6B6B75"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#141521"
  })), react_1.default.createElement("linearGradient", {
    id: "b",
    x1: "36.13%",
    x2: "57.176%",
    y1: "28.991%",
    y2: "72.95%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#11172B"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#1D243B"
  })), react_1.default.createElement("linearGradient", {
    id: "c",
    x1: "56.217%",
    x2: "35.846%",
    y1: "71.075%",
    y2: "27.899%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#6B6B75"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#141521"
  })), react_1.default.createElement("linearGradient", {
    id: "d",
    x1: "43.631%",
    x2: "62.928%",
    y1: "24.372%",
    y2: "77.134%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#282E43"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#373E55"
  })), react_1.default.createElement("linearGradient", {
    id: "e",
    x1: "43.259%",
    x2: "58.882%",
    y1: "30.033%",
    y2: "77.044%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#353B50"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#444B62"
  })), react_1.default.createElement("linearGradient", {
    id: "f",
    x1: "37.597%",
    x2: "44.214%",
    y1: "49.994%",
    y2: "49.994%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#B7BFC7"
  }), react_1.default.createElement("stop", {
    offset: "81.57%",
    stopColor: "#D4DBDF"
  })), react_1.default.createElement("linearGradient", {
    id: "g",
    x1: "36.666%",
    x2: "42.371%",
    y1: "49.886%",
    y2: "49.886%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#ABB2BB"
  }), react_1.default.createElement("stop", {
    offset: "81.57%",
    stopColor: "#C7CED2"
  })), react_1.default.createElement("linearGradient", {
    id: "h",
    x1: "-.001%",
    x2: "99.996%",
    y1: "50.005%",
    y2: "50.005%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#1E6CB5"
  }), react_1.default.createElement("stop", {
    offset: "9.541%",
    stopColor: "#236EB7"
  }), react_1.default.createElement("stop", {
    offset: "30.06%",
    stopColor: "#2570B8"
  }), react_1.default.createElement("stop", {
    offset: "42.69%",
    stopColor: "#1F68B2"
  }), react_1.default.createElement("stop", {
    offset: "60.82%",
    stopColor: "#185FAD"
  }), react_1.default.createElement("stop", {
    offset: "74.41%",
    stopColor: "#165CAB"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#253D81"
  })), react_1.default.createElement("linearGradient", {
    id: "i",
    x1: ".146%",
    x2: "100.098%",
    y1: "49.995%",
    y2: "49.995%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#1E6CB5"
  }), react_1.default.createElement("stop", {
    offset: "9.541%",
    stopColor: "#236EB7"
  }), react_1.default.createElement("stop", {
    offset: "30.06%",
    stopColor: "#2570B8"
  }), react_1.default.createElement("stop", {
    offset: "42.69%",
    stopColor: "#1F68B2"
  }), react_1.default.createElement("stop", {
    offset: "60.82%",
    stopColor: "#185FAD"
  }), react_1.default.createElement("stop", {
    offset: "74.41%",
    stopColor: "#165CAB"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#253D81"
  })), react_1.default.createElement("linearGradient", {
    id: "j",
    x1: "67.401%",
    x2: "36.124%",
    y1: "3.986%",
    y2: "88.51%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#B7BFC7"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#EDF7FD"
  })), react_1.default.createElement("linearGradient", {
    id: "k",
    x1: ".027%",
    x2: "99.916%",
    y1: "50.058%",
    y2: "50.058%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#E1E2E1"
  })), react_1.default.createElement("radialGradient", {
    id: "l",
    cx: "49.234%",
    cy: "37.491%",
    r: "58.921%",
    fx: "49.234%",
    fy: "37.491%",
    gradientTransform: "matrix(.76371 0 0 1 .116 0)"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#636C88"
  }), react_1.default.createElement("stop", {
    offset: "90.11%",
    stopColor: "#353B50"
  })), react_1.default.createElement("linearGradient", {
    id: "m",
    x1: "84.718%",
    x2: "18.171%",
    y1: "5.013%",
    y2: "90.896%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#636C88"
  }), react_1.default.createElement("stop", {
    offset: "90.11%",
    stopColor: "#353B50"
  }))), react_1.default.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, react_1.default.createElement("path", {
    fill: "#000",
    d: "M14.389 27.26s-5 4.559-2.795 7.874c0 0-1.878-1.614-1.114-4.035.743-2.42 2.03-4.23 2.03-4.23l1.879.392zM31.092 38.797s2.249-.37 3.362-.654c1.092-.283 1.9 0 2.053-.065.152-.066.567-.175.917-.48.349-.305 4.847-.37 7.51-2.116 2.664-1.744 3.145-3.642 3.821-4.448.677-.807 1.747-2.138.917-2.29-.83-.153-4.454 0-4.738.458-.305.458-5.633 2.704-5.895 3.01-.262.283-7.947 6.585-7.947 6.585z",
    opacity: ".1"
  }), react_1.default.createElement("g", {
    fill: "#8F97AD"
  }, react_1.default.createElement("path", {
    d: "M41.66 26.497l-1.18-1.374c.044-.043 5.131-4.492 4.804-8.941-.153-2.006-1.398-3.751-3.712-5.234-9.301-5.91-24.585 2.093-24.738 2.18l-.83-1.57c.655-.348 16.354-8.614 26.572-2.115 2.817 1.788 4.367 4.035 4.542 6.63.371 5.365-5.218 10.228-5.459 10.424z"
  }), react_1.default.createElement("path", {
    d: "M41.528 26.345l-.917-1.047c.066-.066 5.219-4.558 4.891-9.116-.153-2.072-1.44-3.882-3.799-5.387-9.41-5.997-24.803 2.094-24.956 2.16l-.655-1.244c.174-.087 4.083-2.159 9.28-3.49 6.964-1.787 12.881-1.308 17.073 1.375 2.773 1.766 4.258 3.947 4.455 6.477.393 5.278-5.131 10.075-5.372 10.272z",
    opacity: ".2"
  }), react_1.default.createElement("path", {
    d: "M41.397 26.192l-.655-.763c.044-.044 5.284-4.624 4.957-9.29-.153-2.138-1.463-3.992-3.887-5.54-9.52-6.041-25 2.115-25.153 2.18l-.48-.893c.153-.088 4.061-2.16 9.236-3.468C32.336 6.652 38.188 7.11 42.336 9.77c2.708 1.723 4.17 3.86 4.367 6.325.371 5.168-5.065 9.9-5.306 10.097z",
    opacity: ".2"
  }), react_1.default.createElement("path", {
    d: "M41.266 26.04l-.393-.459c.044-.043 5.372-4.667 5.022-9.443-.153-2.202-1.506-4.122-3.995-5.692-9.607-6.106-25.197 2.072-25.35 2.16l-.284-.524c.044-.022 4.04-2.137 9.193-3.446 6.855-1.745 12.663-1.287 16.768 1.309 2.664 1.7 4.083 3.773 4.258 6.171.393 5.06-4.978 9.727-5.219 9.923z",
    opacity: ".2"
  }), react_1.default.createElement("path", {
    d: "M41.135 25.887l-.13-.153c.043-.044 5.436-4.732 5.087-9.618-.153-2.268-1.529-4.23-4.083-5.844-9.695-6.172-25.371 2.072-25.546 2.159l-.087-.175c.043-.021 4.017-2.137 9.148-3.445 4.738-1.222 11.485-1.963 16.616 1.286 2.598 1.658 3.995 3.686 4.17 5.998.35 4.994-5.11 9.748-5.175 9.792z",
    opacity: ".2"
  })), react_1.default.createElement("g", {
    fill: "#8F97AD"
  }, react_1.default.createElement("path", {
    d: "M22.707 40.913c-1.921 0-3.995-.262-6.157-.938-6.135-1.897-7.227-5.343-7.336-7.24-.24-4.166 3.603-8.833 9.367-11.384l.698 1.57c-5.021 2.224-8.537 6.302-8.34 9.705.153 2.53 2.27 4.492 6.135 5.692 10.699 3.314 18.8-3.97 18.887-4.035l1.157 1.265c-.087.087-2.249 2.05-5.873 3.576a21.5 21.5 0 0 1-8.538 1.789z"
  }), react_1.default.createElement("path", {
    d: "M22.707 40.716c-1.9 0-3.952-.261-6.113-.937-4.454-1.374-7.009-3.882-7.205-7.066-.24-4.078 3.559-8.68 9.257-11.188l.546 1.221c-5.175 2.29-8.668 6.368-8.45 9.901.153 2.617 2.315 4.646 6.267 5.867 10.808 3.337 18.995-4.013 19.06-4.078l.918.981c-.087.087-2.227 2.028-5.83 3.555-2.118.894-5.043 1.744-8.45 1.744z",
    opacity: ".2"
  }), react_1.default.createElement("path", {
    d: "M22.707 40.542c-1.877 0-3.908-.262-6.048-.916-4.366-1.374-6.877-3.816-7.052-6.913-.24-3.991 3.515-8.527 9.127-11.014l.393.873c-5.262 2.333-8.778 6.477-8.56 10.075.154 2.705 2.359 4.798 6.398 6.041 10.873 3.38 19.17-4.056 19.258-4.122l.655.698c-.088.088-2.206 2.007-5.764 3.512-2.14.915-5.022 1.766-8.407 1.766z",
    opacity: ".2"
  }), react_1.default.createElement("path", {
    d: "M22.707 40.346c-1.855 0-3.886-.262-5.982-.916-5.502-1.701-6.812-4.602-6.943-6.717-.219-3.926 3.471-8.375 9.017-10.817l.24.523c-5.327 2.355-8.886 6.586-8.69 10.272.153 2.791 2.424 4.929 6.529 6.215 11.004 3.403 19.367-4.1 19.454-4.165l.393.414c-.087.088-2.184 1.985-5.72 3.49-2.075.85-4.935 1.7-8.298 1.7z",
    opacity: ".2"
  }), react_1.default.createElement("path", {
    d: "M22.686 40.15c-1.856 0-3.843-.262-5.917-.916-5.393-1.68-6.682-4.493-6.79-6.543-.22-3.838 3.449-8.222 8.907-10.643l.088.175c-5.393 2.377-9.018 6.695-8.8 10.446.11 2.007 1.376 4.733 6.66 6.39 11.114 3.446 19.542-4.122 19.629-4.209l.13.13c-.065.088-5.741 5.17-13.907 5.17z",
    opacity: ".2"
  })), react_1.default.createElement("path", {
    fill: "url(#a)",
    d: "M30.218 13.216c-1.07.305-2.445-.022-3.82-.829-1.485-.85-2.97-2.246-4.04-3.925-1.048-1.614-1.594-3.25-1.55-4.624.022-1.134.458-1.962 1.244-2.399a4322.525 4322.525 0 0 0-19.89 11.537c-.765.436-1.201 1.287-1.223 2.399-.044 1.352.524 2.988 1.55 4.623 1.092 1.701 2.577 3.075 4.04 3.926 1.375.785 2.75 1.134 3.82.829.197-.044.372-.131.524-.218L30.721 13.02c-.153.065-.328.152-.503.196z"
  }), react_1.default.createElement("path", {
    fill: "url(#b)",
    d: "M29.41 11.93c-.83.24-1.9-.023-2.969-.633-1.157-.654-2.293-1.745-3.144-3.053-.808-1.243-1.223-2.508-1.2-3.533.02-.85.348-1.505.938-1.832L3.21 14.372c-.59.349-.917.981-.94 1.832-.021 1.047.394 2.29 1.202 3.533.851 1.308 1.987 2.377 3.144 3.053 1.07.61 2.14.872 2.97.632.152-.043.283-.087.392-.174l19.847-11.515a1.449 1.449 0 0 1-.415.196z"
  }), react_1.default.createElement("path", {
    fill: "url(#c)",
    d: "M29.41 11.93c-.83.24-1.9-.023-2.969-.633-1.157-.654-2.293-1.745-3.144-3.053-.808-1.243-1.223-2.508-1.2-3.533.02-.85.348-1.505.938-1.832L3.21 14.372c-.59.349-.917.981-.94 1.832-.021 1.047.394 2.29 1.202 3.533.851 1.308 1.987 2.377 3.144 3.053 1.07.61 2.14.872 2.97.632.152-.043.283-.087.392-.174l19.847-11.515a1.449 1.449 0 0 1-.415.196zm-16.615 9.028c-.066.044-1.157.698-1.223.72-.131.043-.939 1.09-2.664.937-.524 0-1.179-.218-1.856-.61-1.07-.61-2.096-1.614-2.838-2.748-.699-1.069-1.07-2.18-1.048-3.031.022-.546.044-2.029 1.463-2.203L21.2 4.95c.044 1.155.502 2.464 1.332 3.75.895 1.396 2.118 2.574 3.45 3.337a6.6 6.6 0 0 0 .786.393l-13.974 8.527z"
  }), react_1.default.createElement("path", {
    fill: "#6B6B75",
    d: "M30.11 6.652c-.874-1.374-2.075-2.487-3.276-3.184-1.113-.633-2.205-.916-3.079-.655L3.908 14.328c.874-.24 1.965.022 3.079.654 1.2.698 2.38 1.81 3.275 3.184s1.354 2.792 1.332 3.991c-.022.982-.393 1.702-1.07 2.094l19.847-11.515c.655-.392 1.026-1.112 1.07-2.093.022-1.2-.437-2.617-1.332-3.991z"
  }), react_1.default.createElement("path", {
    fill: "url(#d)",
    d: "M30.96 6.455c-1.091-1.7-2.598-3.118-4.082-3.969-1.376-.785-2.773-1.134-3.843-.829-.197.066-.371.131-.546.24L2.642 13.412c.175-.087.35-.174.546-.24 1.091-.305 2.467.022 3.843.83 1.484.871 2.99 2.267 4.083 3.968 1.113 1.723 1.68 3.468 1.637 4.929-.044 1.221-.502 2.115-1.31 2.595L31.288 13.98c.808-.48 1.267-1.374 1.31-2.595.066-1.461-.524-3.228-1.637-4.929z"
  }), react_1.default.createElement("path", {
    fill: "#777782",
    d: "M30.96 6.455c-1.091-1.7-2.598-3.118-4.082-3.969-1.376-.785-2.773-1.134-3.843-.829-.197.066-.371.131-.546.24L2.642 13.412c.175-.087.35-.174.546-.24 1.091-.305 2.467.022 3.843.83 1.484.871 2.99 2.267 4.083 3.968 1.113 1.723 1.68 3.468 1.637 4.929-.044 1.221-.502 2.115-1.31 2.595l1.965-1.134c.24-.829.24-1.374.24-1.417.044-1.658-.59-3.577-1.79-5.453-1.114-1.788-2.686-3.293-4.367-4.274a7.923 7.923 0 0 0-1.528-.698l16.965-9.857c.109-.066.218-.11.35-.153a2.58 2.58 0 0 1 .61-.087c.743 0 1.616.283 2.533.807 1.42.828 2.795 2.159 3.778 3.685 1.004 1.57 1.462 3.14 1.506 4.427.044 1.134-.218 2.05-.59 2.705l.175-.088c.808-.48 1.267-1.373 1.31-2.595.066-1.44-.524-3.206-1.637-4.907z"
  }), react_1.default.createElement("path", {
    fill: "url(#e)",
    d: "M30.83 4.514c-1.158-1.374-2.533-2.53-3.887-3.293C25.218.218 23.472-.196 22.118.196c-.24.066-.48.175-.677.284L1.594 11.995c.196-.131.437-.218.677-.284 1.353-.392 3.1.044 4.825 1.025 1.463.85 2.904 2.094 4.127 3.62 0 0 1.113 1.353 2.489.48l16.725-9.705c1.68-1.025.393-2.617.393-2.617z"
  }), react_1.default.createElement("path", {
    fill: "#777782",
    d: "M30.83 4.514c-1.158-1.374-2.533-2.53-3.887-3.293C25.218.218 23.472-.196 22.118.196c-.24.066-.48.175-.677.284-.175.087-.327.196-.502.283 1.987-.501 4.41.567 5.568 1.222 1.288.741 2.554 1.81 3.624 3.096.11.153.306.502.262.785-.022.175-.175.328-.415.48l-16.725 9.727h-.022a.77.77 0 0 1-.458.153c-.437 0-.808-.415-.852-.458-1.266-1.57-2.773-2.923-4.366-3.817-1.136-.632-2.642-1.069-3.909-1.156-.677.393-1.375.785-2.052 1.2.196-.131.437-.218.677-.284 1.353-.392 3.1.044 4.825 1.025 1.463.85 2.904 2.094 4.127 3.62 0 0 1.113 1.353 2.489.48l16.725-9.705c1.68-1.025.393-2.617.393-2.617z"
  }), react_1.default.createElement("path", {
    fill: "#5F5F69",
    d: "M30.437 7.131l-16.725 9.705c-1.376.873-2.49-.48-2.49-.48l-.13-.174c-1.201-1.44-2.599-2.639-3.996-3.446-1.725-1.003-3.472-1.417-4.825-1.025-1.332.37-2.096 1.505-2.14 3.184-.044 1.636.611 3.599 1.834 5.496 1.223 1.92 2.904 3.468 4.563 4.449 1.55.894 3.1 1.265 4.302.916 1.2-.35 1.877-1.352 1.921-2.835.044-1.461-.546-3.228-1.637-4.929-1.092-1.701-2.599-3.119-4.083-3.97-1.376-.784-2.773-1.133-3.843-.828-1.07.305-1.681 1.221-1.725 2.552-.044 1.33.48 2.9 1.485 4.427.982 1.526 2.314 2.77 3.646 3.555 1.244.72 2.467 1.003 3.45.741.96-.283 1.506-1.09 1.55-2.29.044-1.177-.437-2.595-1.332-3.99-.873-1.375-2.074-2.487-3.275-3.185-1.114-.632-2.205-.916-3.079-.654l.48 1.003c.743-.218 1.66.022 2.599.567 1.004.589 2.009 1.527 2.751 2.683.699 1.09 1.07 2.18 1.048 3.096-.022.938-.458 1.549-1.223 1.767-.83.24-1.9-.022-2.97-.632-1.156-.655-2.292-1.745-3.143-3.054-.808-1.243-1.223-2.508-1.201-3.533.022-1.068.524-1.788 1.397-2.028.94-.262 2.162.022 3.363.72 1.31.763 2.598 1.984 3.559 3.467.917 1.418 1.397 2.857 1.375 4.057-.043 1.221-.611 2.05-1.594 2.333-1.07.306-2.445-.022-3.82-.828-1.485-.851-2.97-2.247-4.04-3.926-1.048-1.614-1.594-3.25-1.55-4.623.044-1.396.699-2.334 1.834-2.661 1.223-.349 2.795.022 4.345.938 1.244.72 2.489 1.766 3.559 3.053l.109.13s1.114 1.353 2.49.48L30 7.656c.306-.196.524-.393.655-.61-.087 0-.153.043-.218.086z"
  }), react_1.default.createElement("g", null, react_1.default.createElement("path", {
    fill: "#000",
    d: "M16.157 27.784c-.546.305-.546.829 0 1.156l11.31 6.412c.546.305 1.441.305 1.987 0l16.769-9.487c.546-.305.546-.829 0-1.156l-11.747-6.695c-.546-.305-1.441-.305-1.987 0l-16.332 9.77z",
    opacity: ".1"
  }), react_1.default.createElement("path", {
    fill: "#EFF8FD",
    d: "M46.157 16.553L34.825 10.01c-.458-.262-1.179-.196-1.615.131L16.07 23.226c-.437.327-.437.829.022 1.09l11.332 6.543c.458.262 1.179.196 1.615-.153l17.14-13.085c.437-.327.437-.807-.022-1.068z"
  }), react_1.default.createElement("path", {
    fill: "#EEF1F4",
    d: "M28.057 30.88c-.24 0-.437-.043-.612-.152l-11.331-6.542c-.175-.11-.284-.24-.284-.415-.022-.174.087-.37.284-.501l17.14-13.085c.218-.175.567-.284.894-.284.24 0 .459.044.612.153l11.332 6.542c.174.11.284.24.284.415.021.174-.088.37-.284.501l-17.14 13.085c-.218.175-.568.284-.895.284z"
  }), react_1.default.createElement("path", {
    fill: "url(#f)",
    d: "M31.004 7.306c-.021.174-.13.349-.327.501l-17.14 13.086c-.437.327-1.157.392-1.616.152L.59 14.503C.37 14.372.262 14.197.24 14L.066 17.36c0 .218.109.414.349.545l11.506 6.76c.459.262 1.18.197 1.616-.152l17.467-12.104c.219-.174.328-.37.328-.567l-.328-4.536z",
    transform: "translate(15.502 9.814)"
  }), react_1.default.createElement("path", {
    fill: "url(#g)",
    d: "M13.537 24.535c-.437.327-1.157.392-1.616.152L.83 18.167l-.022.348c0 .153.109.328.327.458l10.874 6.26c.436.24 1.135.24 1.572 0l16.725-9.662c.218-.13.327-.283.327-.458l.35-2.66-17.446 12.082z",
    transform: "translate(15.502 9.814)"
  }), react_1.default.createElement("path", {
    fill: "url(#h)",
    d: "M28.93 7.022l-9.934-5.735c-.306-.175-.83-.131-1.136.109L8.08 8.876c-.306.24-.415.633-.262.894l1.506 2.29c1.005-.109 2.227.153 3.275.763 1.048.611 1.616 1.396 1.594 2.072l3.646.654c.415.066 1.005-.065 1.31-.283l9.804-7.48c.284-.262.284-.59-.022-.764z",
    transform: "translate(15.502 9.814)"
  }), react_1.default.createElement("path", {
    fill: "url(#i)",
    d: "M12.227 13.107c1.354.785 1.834 1.875 1.07 2.464-.764.59-2.467.415-3.821-.37-1.354-.786-1.834-1.876-1.07-2.465.764-.567 2.467-.392 3.821.37z",
    transform: "translate(15.502 9.814)"
  }), react_1.default.createElement("path", {
    fill: "url(#j)",
    d: "M12.598 12.823c-1.048-.61-2.27-.872-3.275-.763-.524.044-.96.196-1.31.458-.982.742-.502 2.05 1.092 2.966 1.594.916 3.602 1.047 4.563.305.328-.24.48-.567.502-.894.044-.676-.502-1.461-1.572-2.072zm.699 2.748c-.764.59-2.467.415-3.821-.37-1.354-.786-1.834-1.876-1.07-2.465s2.467-.414 3.821.37c1.354.786 1.834 1.898 1.07 2.465z",
    transform: "translate(15.502 9.814)"
  }), react_1.default.createElement("path", {
    fill: "#13416D",
    d: "M42.009 17.229l-7.686-4.427c-.153-.088-.415-.066-.568.043l-6.9 5.278c-.152.109-.152.283 0 .37l7.686 4.428c.153.087.415.065.568-.044l6.9-5.278c.153-.109.153-.283 0-.37z"
  }), react_1.default.createElement("path", {
    fill: "url(#k)",
    d: "M18.559 3.14l-6.965 5.322 5.13 2.966 6.988-5.322z",
    transform: "translate(15.502 9.814)"
  }), react_1.default.createElement("path", {
    fill: "#89948E",
    d: "M34.061 13.063l5.066 2.923.087-.066-5.153-2.966-6.965 5.322.087.043z"
  }), react_1.default.createElement("g", {
    fill: "#2E393C"
  }, react_1.default.createElement("path", {
    d: "M38.21 15.986v.087l-.153.022-.59-.35v-.086h.153zM37.445 16.574v.088l-.13.022-.612-.35v-.087l.153-.021zM36.66 16.247v.088l-.568.458h-.131l-.022-.088.59-.436zM38.21 16.116v.088l-.59.436-.13.022v-.088l.567-.458zM36.681 17.163v.088h-.13l-.59-.328v-.109h.13zM37.118 15.353v.087h-.131l-.59-.327v-.087l.131-.022zM36.354 15.92v.087l-.131.022-.59-.349v-.087h.131zM37.118 15.462v.087l-.568.458h-.153v-.087l.59-.436zM35.59 16.509v.087l-.131.022-.59-.349v-.087L35 16.16zM36.354 16.051v.087l-.568.436-.153.022v-.087l.59-.458zM36.004 14.852v.087l-.567.436-.153.022v-.087l.59-.458zM35.24 15.44v.088l-.568.436-.152.022v-.11l.59-.436z"
  })), react_1.default.createElement("g", {
    fill: "#2E393C"
  }, react_1.default.createElement("path", {
    d: "M35.983 17.687v.109h-.131l-.612-.327v-.11h.153zM35.197 17.381v.088l-.568.436-.131.022-.022-.11.59-.436zM35.218 18.276v.087l-.13.022-.59-.35v-.087h.13zM34.432 17.948v.11l-.567.436h-.131v-.088l.567-.436zM35.983 17.818v.087l-.59.458h-.131v-.087l.59-.437zM34.454 18.864v.088l-.13.021-.59-.349v-.087l.13-.022zM35.218 18.406v.088l-.567.436-.153.022v-.088l.59-.458zM34.89 17.054v.087l-.13.022-.59-.349v-.087l.131-.022zM34.127 16.727v.087l-.59.458h-.13v-.087l.567-.436zM34.89 17.185v.087l-.567.437-.153.021v-.109l.59-.436zM34.127 17.752v.087l-.568.458h-.131v-.087l.568-.436z"
  })), react_1.default.createElement("g", {
    fill: "#2E393C"
  }, react_1.default.createElement("path", {
    d: "M33.734 19.41v.065l-.11.022-.502-.284v-.087h.131zM33.1 19.148v.065l-.48.371h-.13v-.065l.48-.371zM33.1 19.89v.087h-.109l-.502-.284v-.065l.131-.022zM33.734 19.519v.065l-.48.37h-.11v-.065l.48-.37zM32.467 20.37v.086h-.109l-.502-.283v-.066l.13-.021zM33.1 19.998v.066l-.48.37-.11.022v-.087l.481-.37zM32.838 18.864v.088h-.109l-.502-.284v-.065l.11-.022zM32.205 19.344v.087h-.109l-.502-.261v-.088h.11zM31.55 19.082v.088l-.48.37h-.11v-.087l.481-.349zM32.838 18.973v.088l-.48.349-.11.021v-.087l.481-.37zM31.572 19.846v.065l-.11.022-.501-.284v-.087h.109zM32.205 19.453v.087l-.48.371h-.11v-.087l.481-.349z"
  }))), react_1.default.createElement("g", null, react_1.default.createElement("path", {
    fill: "url(#l)",
    d: "M15.611.96c-.37-.698-1.506-.938-2.336-.676-.83.261-1.223.24-1.812.13-.59-.087-3.144-.523-6.026 1.614C2.555 4.165 2.249 7.982 1.92 8.396 1.572 8.811.873 9.923.873 9.923l1.158 1.68 1.68-.306s5.044.676 7.599-1.243c2.358-1.789 3.188-5.038 3.231-5.736 0-.676 1.922-1.766 1.07-3.358z",
    transform: "translate(33.843 25.08)"
  }), react_1.default.createElement("path", {
    fill: "#444B62",
    d: "M48.362 29.398c.022-.654 1.725-1.658 1.201-3.097-.458.938-1.157 2.18-1.746 2.42 0 0-1.07 3.403-4.433 5.584-3.34 2.18-6.397 1.352-6.397 1.352l-1.485.523.35.502 1.68-.305s5.044.676 7.599-1.243c2.358-1.767 3.188-5.038 3.231-5.736z",
    opacity: ".1"
  }), react_1.default.createElement("path", {
    fill: "url(#m)",
    d: "M3.537 1.09L1.877.13c-.196-.108-.436-.086-.72.066C.59.523.131 1.33.131 1.985c0 .327.11.567.306.676l1.66.96c.196.108.436.086.72-.066.567-.327 1.026-1.134 1.026-1.789 0-.348-.11-.588-.306-.676z",
    transform: "translate(33.843 34.457)"
  }), react_1.default.createElement("path", {
    fill: "#373E55",
    d: "M37.686 36.202c0 .654-.459 1.461-1.027 1.788-.283.153-.545.175-.72.066-.197-.11-.306-.327-.306-.676 0-.654.459-1.461 1.026-1.789.284-.152.546-.174.72-.065.197.11.307.349.307.676z"
  }))));
};